import { useFormat } from '@k2/ui/format'
import { useI18n } from 'vue-i18n'
import type { Organization } from '../store'

// One place, so the picker and the sidebar switcher cannot drift apart.
export const useOrganizationMeta = () => {
  const { t } = useI18n()
  const { date } = useFormat()

  const key = (organization: Organization) => {
    if (organization.invitedAt) return 'organizations.memberMeta'
    // An agency you created is not a personal workspace, though both are yours.
    return organization.verified ? 'organizations.agencyMeta' : 'organizations.ownMeta'
  }

  const meta = (organization: Organization) =>
    t(key(organization), {
      brands: organization.brandCount,
      ...(organization.invitedAt ? { date: date(organization.invitedAt, 'dayMonth') } : {})
    })

  return { meta }
}
